import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../shared/api/client";
import { PageHeader } from "../../shared/components/PageHeader";
import { Empty, Loading } from "../../shared/components/Empty";
import { Pill } from "../../shared/components/Pill";

type Notif = {
  id: number; type: string; title: string; body: string | null;
  link: string | null; is_read: boolean; created_at: string;
};

export default function NotificationsPage() {
  const [params] = useSearchParams();
  const onlyUnread = params.get("filter") === "unread";
  const [items, setItems] = useState<Notif[] | null>(null);

  const reload = () => {
    const p = new URLSearchParams();
    if (onlyUnread) p.set("unread_only", "true");
    p.set("limit", "100");
    api.get<Notif[]>(`/notifications?${p}`).then((r) => setItems(r.data));
  };
  useEffect(() => { reload(); }, [onlyUnread]);

  const markAll = async () => { await api.post("/notifications/read", { all: true }); reload(); };

  return (
    <>
      <PageHeader title="알림" subtitle={onlyUnread ? "안 읽음 만" : "전체"}
        right={<button className="t-btn t-btn-outline" onClick={markAll}>모두 읽음</button>}
      />
      <div className="t-grid cols-1">
        {items === null && <Loading/>}
        {items?.length === 0 && <Empty msg="알림이 없습니다"/>}
        <div className="t-card" style={{ padding: 0 }}>
          <div className="t-list" style={{ padding: 16 }}>
            {items?.map((n) => (
              <div key={n.id} className={`t-row clickable ${!n.is_read ? "unread" : ""}`}>
                <Pill kind="info">{n.type}</Pill>
                <div style={{ flex: 1 }}>
                  <div className="title">{n.title}</div>
                  {n.body && <div className="meta" style={{ marginTop: 2 }}>{n.body}</div>}
                </div>
                <span className="meta">{new Date(n.created_at).toLocaleString("ko-KR")}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
